module.exports = __webpack_public_path__ + "static/img/pdf.2a845f68.png";